import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { JsonPipe } from '@angular/common';
import { BackendService } from '../../services/backend-service';
import { Checkout } from '../checkout/checkout';
import { CheckoutPagesDTO } from '../../types/api.types';

@Component({
  selector: 'app-landing-page',
  imports: [JsonPipe, Checkout],
  templateUrl: './landing-page.html'
})

export class LandingPage implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private router: Router,
    private backendService: BackendService    
  ) {}
  devMode: boolean = true;
  checkoutPagesRetrieved?: CheckoutPagesDTO[];
  landingPageId: string | null = null;
  contextSessionId: string | null = null;
  allCookies: { key: string, value: string }[] = [];
  errorMessage: string | null = null;
  
    ngOnInit() {
    // Snapshot — use when the param won't change while the component is alive
    this.landingPageId = this.route.snapshot.paramMap.get('id');

    // // Cookie session logic, TODO
    // this.contextSessionId = this.route.snapshot.queryParamMap.get('ctx');

    // if (this.contextSessionId) {
    //   this.cookieService.set('contextSessionId', this.contextSessionId);
    //   this.router.navigate([], {
    //     relativeTo: this.route,
    //     queryParams: {},
    //     replaceUrl: true  // replaces history entry so back button isn't affected
    // });
    // } else if (this.cookieService.check('contextSessionId')) {
    //   this.contextSessionId = this.cookieService.get('contextSessionId');
    // }

    // const cookies = this.cookieService.getAll();
    // this.allCookies = Object.entries(cookies).map(([key, value]) => ({ key, value }));

    this.fetchData();
  }
  
  fetchData() {
    if (!this.landingPageId) {
      console.error('No landing page ID found in route');
      return;
    }

    this.backendService.getLandingPage(this.landingPageId).subscribe({
      next: (response: CheckoutPagesDTO[]) => {
        this.checkoutPagesRetrieved = response;
      },
      error: (err: any) => {
        console.error('Failed to fetch:', err);
      }
    });
    }

    onCheckoutError(message: string) {
      this.errorMessage = message;
    }
}